<div class="dialog-container" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="24px">
    <ui-kit-svg class="close-icon" name="ic_cross" (click)="dialogRef.close()"/>
    <div class="h3">
        @if (dialogData.participantRole) {
            {{ 'i18n_af_labelClassificationTableRow#' + dialogData.row + '#' + dialogData.participantRole | translate}}
        } @else {
            {{ 'i18n_af_labelClassificationTableRow#' + dialogData.row | translate }}
        }
    </div>
    <div class="dialog-content" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="24px">
        <div class="t2-semi-bold">{{
                'i18n_af_labelClassificationTableCellDetailsDialogContentLabel#' + contentLabelPostfix | translate: {
                    dateFrom: dialogData.selectedDateRange.dateFrom | date:'dd.MM.yyyy',
                    dateTo: dialogData.selectedDateRange.dateTo | date:'dd.MM.yyyy'
                }
            }}
        </div>
        <div class="grid-container">
            @for (cell of filteredCellData; track cell) {
                <div class="cell label">
                    {{ (dialogData.translationPostfix ? 'i18n_af_labelClassificationTableCell' + dialogData.translationPostfix + '#' + cell.label : cell.label) | translate }}
                </div>
                <div
                    class="cell count">{{ cell.count ? (cell.count | numberTriplesFormat) : '-' }}
                </div>
                <div class="cell percentage"
                     [class.alert]="cell.hasAlert"
                     [class.feature]="dialogData.column === 'forecastFuture'">
                    {{ cell.value ? cell.value + '%' : '-' }}
                </div>
            }
        </div>
    </div>
</div>
